<template>
    <main-content>
        <Wallets></Wallets>
    </main-content>
</template>

<script>
    import Wallets from './components/wallets';
    import MainContent from "@/components/main-content";

    export default {
        components: {
            Wallets,
            MainContent,
        },
    };
</script>